import React from "react";
import { CONTACT } from "@/lib/data";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";

export const Contact = ({ onBookClick }) => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#4B0082] font-semibold mb-4">
              Get in touch
            </div>
            <h2 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight text-slate-900 leading-tight mb-6">
              Ready to make your car shine?
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed mb-10">
              Text, call, or book online. We respond within an hour during
              business hours.
            </p>

            <div className="space-y-5">
              <a
                href={`tel:${CONTACT.phone}`}
                data-testid="contact-phone-link"
                className="flex items-center gap-4 p-5 border border-slate-200 rounded-xl hover:border-[#4B0082] hover:bg-[#F3E8FF]/30 transition-all group"
              >
                <div className="w-12 h-12 rounded-md bg-[#F3E8FF] flex items-center justify-center group-hover:bg-[#4B0082] transition-colors">
                  <Phone className="w-5 h-5 text-[#4B0082] group-hover:text-white transition-colors" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-0.5">
                    Call or text
                  </div>
                  <div className="font-heading font-semibold text-slate-900 text-lg">
                    {CONTACT.phoneDisplay}
                  </div>
                </div>
              </a>

              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="contact-email-link"
                className="flex items-center gap-4 p-5 border border-slate-200 rounded-xl hover:border-[#4B0082] hover:bg-[#F3E8FF]/30 transition-all group"
              >
                <div className="w-12 h-12 rounded-md bg-[#F3E8FF] flex items-center justify-center group-hover:bg-[#4B0082] transition-colors">
                  <Mail className="w-5 h-5 text-[#4B0082] group-hover:text-white transition-colors" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-0.5">
                    Email
                  </div>
                  <div className="font-heading font-semibold text-slate-900 text-lg break-all">
                    {CONTACT.email}
                  </div>
                </div>
              </a>

              <div className="flex items-center gap-4 p-5 border border-slate-200 rounded-xl">
                <div className="w-12 h-12 rounded-md bg-[#F3E8FF] flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-[#4B0082]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-0.5">
                    Service area
                  </div>
                  <div className="font-heading font-semibold text-slate-900 text-lg">
                    {CONTACT.area}
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4 p-5 border border-slate-200 rounded-xl">
                <div className="w-12 h-12 rounded-md bg-[#F3E8FF] flex items-center justify-center">
                  <Clock className="w-5 h-5 text-[#4B0082]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-0.5">
                    Hours
                  </div>
                  <div className="font-heading font-semibold text-slate-900 text-lg">
                    Mon – Sat · 10 AM – 6 PM
                  </div>
                </div>
              </div>

              <div className="pt-2">
                <div className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-3">
                  Follow our work
                </div>
                <div className="flex items-center gap-3">
                  <a
                    href={CONTACT.socials.instagram.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-instagram-link"
                    className="flex items-center gap-3 px-5 py-3 border border-slate-200 rounded-xl hover:border-[#4B0082] hover:bg-[#F3E8FF]/30 transition-all group"
                  >
                    <Instagram className="w-5 h-5 text-[#4B0082]" />
                    <span className="font-medium text-slate-900">
                      {CONTACT.socials.instagram.handle}
                    </span>
                  </a>
                  <a
                    href={CONTACT.socials.facebook.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-facebook-link"
                    className="flex items-center gap-3 px-5 py-3 border border-slate-200 rounded-xl hover:border-[#4B0082] hover:bg-[#F3E8FF]/30 transition-all group"
                  >
                    <Facebook className="w-5 h-5 text-[#4B0082]" />
                    <span className="font-medium text-slate-900">
                      {CONTACT.socials.facebook.handle}
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};
